module.exports = __webpack_public_path__ + "img/top-up.3cbdd52.png";